var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "booking-add-ons-sidebar",
      attrs: {
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "booking-add-ons-sidebar-title",
      },
    },
    [
      _c("div", { staticClass: "booking-header-extension" }, [
        _c(
          "div",
          {
            staticClass: "booking-header-close",
            attrs: { "data-component": "booking-header-close" },
          },
          [
            _c("button", {
              staticClass: "icon-close",
              attrs: { "aria-label": _vm.tc("booking.close"), tabindex: "0" },
              on: {
                click: _vm.deactivate,
                keypress: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.deactivate($event)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar",
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.deactivate($event)
                  },
                ],
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "booking-header-extension-wrapper container" },
          [
            _c("div", { staticClass: "booking-header-extension-left" }, [
              _vm.addOn.addOnName
                ? _c(
                    "div",
                    {
                      staticClass: "title",
                      attrs: { id: "booking-add-ons-sidebar-title" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.addOn.addOnName) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "booking-add-ons-sidebar__wrapper" }, [
        _vm.addOn.addOnImage
          ? _c("div", { staticClass: "booking-add-ons-sidebar__image" }, [
              _c(
                "picture",
                {
                  directives: [
                    {
                      name: "lazyload",
                      rawName: "v-lazyload",
                      value: {
                        src: _vm.addOn.addOnImage,
                        set: [
                          { width: "480", height: "240", breakpoint: "xs" },
                          { width: "800", height: "360", breakpoint: "md" },
                        ],
                        fit: "crop",
                        align: "center",
                      },
                      expression:
                        "{\n          src: addOn.addOnImage,\n          set: [\n            { width: '480', height: '240', breakpoint: 'xs' },\n            { width: '800', height: '360', breakpoint: 'md' }\n          ],\n          fit: 'crop',\n          align: 'center'\n        }",
                    },
                  ],
                  staticClass: "image-wrapper",
                },
                [
                  _c("img", {
                    staticClass: "image",
                    attrs: {
                      src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                      alt: _vm.addOn.addOnName,
                    },
                  }),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "booking-add-ons-sidebar__content" }, [
          _vm.addOnPrice
            ? _c("div", { staticClass: "booking-add-ons-sidebar__eyebrow" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.priceAndTypeLabel) + "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "booking-add-ons-sidebar__header" }, [
            _vm._v("\n        " + _vm._s(_vm.addOn.addOnName) + "\n      "),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "booking-add-ons-sidebar__description",
            domProps: { innerHTML: _vm._s(_vm.addOn.addOnDescription) },
          }),
          _vm._v(" "),
          _vm.isFeesMessageVisible
            ? _c(
                "div",
                { staticClass: "booking-add-ons-sidebar__fees-message" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.modifyReservationAddOnsCancelPopupFeesMessage
                      ) +
                      "\n      "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "booking-add-ons-sidebar__form" },
            [
              _c(_vm.addOnVariant, {
                ref: "input",
                tag: "component",
                attrs: { "add-on": _vm.addOn, data: _vm.value.data },
                on: {
                  "reset-quantity": _vm.handleResetQuantity,
                  "is-valid": function ($event) {
                    _vm.isValid = $event
                  },
                  input: function ($event) {
                    _vm.formData = $event
                  },
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "booking-add-ons-sidebar__footer" }, [
        _c(
          "div",
          {
            staticClass: "booking-add-ons-sidebar__footer-wrapper",
            class: {
              "--no-selector":
                !_vm.showAdultSelector &&
                !_vm.showChildSelector &&
                !_vm.showQuantitySelector,
              "--only-one-selector": _vm.showOnlyOneSelector,
            },
          },
          [
            _vm.showQuantitySelector
              ? _c("BookingAddOnsQuantitySelector", {
                  class: [
                    "--quantity-selector",
                    {
                      "--only-one-selector": _vm.showOnlyOneSelector,
                    },
                  ],
                  attrs: {
                    title: _vm.quantitySelectorTitle,
                    "max-quantity": _vm.maxQuantity,
                    "min-quantity": 1,
                    "price-and-type-label": _vm.priceAndTypeLabel,
                  },
                  model: {
                    value: _vm.selectedQuantity,
                    callback: function ($$v) {
                      _vm.selectedQuantity = $$v
                    },
                    expression: "selectedQuantity",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showAdultSelector
              ? _c("BookingAddOnsQuantitySelector", {
                  class: [
                    "--adult-selector",
                    {
                      "--only-one-selector": _vm.showOnlyOneSelector,
                    },
                  ],
                  attrs: {
                    title: _vm.adultSelectorTitle,
                    "max-quantity": _vm.maxAdultQuantity,
                    "min-quantity": _vm.minAdultQuantity,
                    "price-and-type-label": _vm.priceAndTypeLabel,
                  },
                  model: {
                    value: _vm.selectedAdultGuestQuantity,
                    callback: function ($$v) {
                      _vm.selectedAdultGuestQuantity = $$v
                    },
                    expression: "selectedAdultGuestQuantity",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showChildSelector
              ? _c("BookingAddOnsQuantitySelector", {
                  staticClass: "--children-selector",
                  attrs: {
                    title: _vm.childrenSelectorTitle,
                    "max-quantity": _vm.maxChildQuantity,
                    "min-quantity": _vm.minChildQuantity,
                    "show-tooltip": _vm.addOn.excludeKidsFromPriceCalculations,
                    "tooltip-message":
                      _vm.addOnsComponentData.TooltipChildrenNotIncluded,
                  },
                  model: {
                    value: _vm.selectedChildGuestQuantity,
                    callback: function ($$v) {
                      _vm.selectedChildGuestQuantity = $$v
                    },
                    expression: "selectedChildGuestQuantity",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "booking-add-ons-sidebar__footer__total" },
              [
                _c(
                  "span",
                  {
                    staticClass: "booking-add-ons-sidebar__footer__total-label",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.tc("booking.total")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "booking-add-ons-sidebar__footer__total-value",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.totalPriceFormatted) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "booking-add-ons-sidebar__footer__add-cart-cta",
                class: [{ loading: _vm.cartPending }],
                attrs: { disabled: !_vm.isValid },
                on: { click: _vm.updateValue },
              },
              [_vm._v("\n        " + _vm._s(_vm.addToCartLabel) + "\n      ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }